import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgInvitePeopleUrl from '@/assets/misc/img_invite-people.svg'
import InviteUsersIllustration from '@/components/SpotIllustration/InviteUsersIllustration'

export interface OCRConfirmBulkSubmitDialogProps {
  showing: boolean
  selectedCount: number
  onClose: () => unknown
  onConfirm: () => unknown
}

export function OCRConfirmBulkSubmitDialog({
  showing,
  selectedCount,
  onClose,
  onConfirm,
}: OCRConfirmBulkSubmitDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgInvitePeopleUrl}
            illustration={byDesign(undefined, InviteUsersIllustration)}
          />
          <ModalSheetContentTitle>
            You are about to submit {selectedCount} jobs
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you submit you will no longer
            be able to make any more changes.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
          <Button label="Submit" variant="primary" onPress={onConfirm} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
